var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHbhLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.884521H4.82517C7.49005 0.884521 9.65035 3.04483 9.65035 5.7097C9.65035 8.37457 7.49005 10.5349 4.82517 10.5349H0V0.884521Z",
    fill: "#655EB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4651H4.82517C7.49005 12.4651 9.65035 14.6254 9.65035 17.2903C9.65035 19.9551 7.49005 22.1154 4.82517 22.1154H0V12.4651Z",
    fill: "#655EB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7693 10.1155C15.0079 10.1155 12.7693 7.8769 12.7693 5.11548L12.7693 0.884709L22.0001 0.884709L22.0001 10.1155L17.7693 10.1155Z",
    fill: "#655EB3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7693 22.1155L12.7693 12.8847L17.0001 12.8847C19.7615 12.8847 22.0001 15.1233 22.0001 17.8847L22.0001 22.1155L12.7693 22.1155Z",
    fill: "#655EB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbhLogo);
export default __webpack_public_path__ + "static/media/hbhLogo.0430b984368cfb4ab635879294d81c5e.svg";
export { ForwardRef as ReactComponent };